import {
  DeviceConsumable,
  DeviceType,
  Status,
  Task,
  TaskStep,
} from "graphql/types"

// Dummy Persons --> Haufe
const dummyPersons = [
  {
    id: "1",
    avatarURL: "/avatar1.png",
    firstName: "Bart",
    lastName: "Simpson",
    email: "max.mustermann@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "2",
    avatarURL: "/avatar2.png",
    firstName: "Lisa",
    lastName: "Simpson",
    email: "anna.schneider@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "3",
    avatarURL: "/avatar3.png",
    firstName: "Homer",
    lastName: "Simpson",
    email: "peter.mueller@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "4",
    avatarURL: "/avatar4.png",
    firstName: "Marge",
    lastName: "Simpson",
    email: "julia.koch@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "5",
    avatarURL: "/avatar8.png",
    firstName: "Maggie",
    lastName: "Simpson",
    email: "lukas.becker@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
]

// Dummy Besucher --> Besucherverwaltung
const dummyVisitors = [
  {
    id: "6",
    avatarURL: "/avatar5.png",
    firstName: "Doctor",
    lastName: "Müller",
    email: "max.mustermann@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "7",
    avatarURL: "/avatar6.png",
    firstName: "Eugen",
    lastName: "Becker",
    email: "anna.schneider@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "8",
    avatarURL: "/avatar7.png",
    firstName: "Krusty",
    lastName: "Clown",
    email: "peter.mueller@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "9",
    avatarURL: "",
    firstName: "Julia",
    lastName: "Jonas",
    email: "julia.koch@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
  {
    id: "10",
    avatarURL: "",
    firstName: "Peter",
    lastName: "Shaw",
    email: "lukas.becker@example.com",
    phone: "0176 12345678",
    jobTitle: "Technischer Ansprechpartner",
  },
]

// Dummy Companies --> Haufe
const dummyCompanies = [
  { id: "1", name: "Musterfirma GmbH" },
  { id: "2", name: "Schneider & Co. KG" },
  { id: "3", name: "Tech Solutions AG" },
  { id: "4", name: "Innovatech GmbH" },
  { id: "5", name: "Becker Engineering" },
]

const dummyDevices: DeviceConsumable[] = [
  {
    id: "5",
    barcode: "CON001",
    name: "Seife A",
    description: "Ein Verbrauchsmaterial für Tests",
    type: DeviceType.CONSUMABLE,
    amount: 1.2,
    unit: "ml",
    charge: "TT17-2a",
    images: [],
    documents: [],
  },
  {
    id: "6",
    barcode: "CON002",
    name: "Staub B",
    description: "Ein weiteres Verbrauchsmaterial",
    type: DeviceType.CONSUMABLE,
    amount: 2.5,
    unit: "g",
    charge: "TT17A",
    images: [],
    documents: [],
  },
  {
    id: "12",
    barcode: "CON003",
    name: "Seife C",
    description: "Ein Verbrauchsmaterial für Tests",
    type: DeviceType.CONSUMABLE,
    amount: 1.2,
    unit: "ml",
    charge: "TT17-2a",
    images: [],
    documents: [],
  },
  {
    id: "13",
    barcode: "CON004",
    name: "Staub D",
    description: "Ein weiteres Verbrauchsmaterial",
    type: DeviceType.CONSUMABLE,
    amount: 2.5,
    unit: "g",
    charge: "TT17A",
    images: [],
    documents: [],
  },
]

// Dummy Tasks --> Projekt Portal

export const standardTask: Task[] = [
  {
    id: "5",
    name: "Engineering",
    info: "",
    status: Status.OPEN,
    examinator: dummyPersons[0],
    testDatas: [],
    taskSteps: [TaskStep.ENGINEERING, TaskStep.HELPER],
    estimatedTime: 0,
    workingTime: 0,
  },
  {
    id: "6",

    name: "Wartezeit",
    info: "Hier können Wartezeiten erfasst werden.",
    status: Status.OPEN,
    examinator: dummyPersons[0],
    testDatas: [],
    taskSteps: [TaskStep.WAITING_TIME],
    estimatedTime: 0,
    workingTime: 0,
  },
]

export { dummyCompanies, dummyDevices, dummyPersons, dummyVisitors }
